import { toast } from 'react-toastify';
import { userService } from '../services';
import { API_FAILURE_ERROR } from '../constants';
import { updateLocalStorage } from '../helpers';

export const setUserRole = (data) => ({
  type: 'SET_ROLE',
  payload: data,
});
export const setPrivacyAcceptanceStatus = (data) => ({
  type: 'ACCEPT_POLICY',
  payload: data,
});
export const setSubscription = (data) => ({
  type: 'SET_SUBSCRIPTION',
  payload: data,
});

export const fetchOnBoardProgress = () => async (dispatch) => {
  try {
    const response = await userService.onboarding_progress();
    if (response.status) {
      dispatch({ type: 'SET_ONBOARD_PROGRESS', payload: response.data });
    }
  } catch {
    toast.error(API_FAILURE_ERROR);
  }
};

export const fetchCardStatus = () => async (dispatch) => {
  const response = await userService.card_status();
  if (response.status) {
    dispatch({ type: 'SET_CARD_EXPIRY', payload: response.data });
  }
};

export const fetchAccountDetails = () => async (dispatch) => {
  const response = await userService.get_account_details({
    teamOwnerId: localStorage.getItem('teamOwnerId'),
  });
  if (response.data) {
    updateLocalStorage({
      activeMembers: response.data.activeMembers,
      maxMembersAllowed: response.data.maxMembersAllowed,
      isMobileTracking: response.data.isMobileTracking,
      isTimesheetApproval: response.data.isTimesheetApproval,
    });
    if (response.data.isTimesheetApproval) {
      dispatch({ type: 'ENABLE_TS_APPROVAL' });
    } else {
      dispatch({ type: 'DISABLE_TS_APPROVAL' });
    }
  }
};
